import Vue from 'vue';
import VueWait from 'vue-wait';
import BootstrapVue from 'bootstrap-vue';
import * as mixins from '@/utils/mixins';
import App from '@/App';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import '@/plugins';
import '@/filters';

import Notification from '@/components/Notification';
import TeamSwitcherModal from '@/components/modals/TeamSwitcherModal';
import ContactModal from '@/components/modals/ContactModal';
import RegistrationModal from '@/components/modals/RegistrationModal';
import WSTableMeta from '@/components/WSTableMeta';
import NavSidebar from '@/components/NavSidebar';
import HelpSidebar from '@/components/HelpSidebar';
import FullWidthBar from '@/components/FullWidthBar';


Vue.component('notification', Notification); //eslint-disable-line
Vue.component('team-switcher-modal', TeamSwitcherModal);
Vue.component('contact-modal', ContactModal);
Vue.component('registration-modal', RegistrationModal);
Vue.component('ws-table-meta', WSTableMeta);
Vue.component('nav-sidebar', NavSidebar);
Vue.component('help-sidebar', HelpSidebar);
Vue.component('full-width-bar', FullWidthBar);
Vue.component('b-sidebar', BootstrapVue.BSidebar);
Vue.component('b-tabs', BootstrapVue.BTabs);
Vue.component('b-nav', BootstrapVue.BNav);
Vue.component('b-navbar', BootstrapVue.BNavbar);

Vue.directive('b-scrollspy', BootstrapVue.VBScrollspy);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

Vue.use(VueWait);
Vue.use(BootstrapVue)
Vue.prototype.loadedActions = [];
Vue.use(require('vue-moment'));

Vue.mixin({
    methods: {...mixins},
});

new Vue({
    router,
    store,
    wait: new VueWait({useVuex: true}),
    data() {
        return {
            firstLoad: false,
            windowWidth: window.innerWidth,
            dispatch: [],
        };
    },
    computed: {
        sidebarDisplayed() {
            return this.$store.state.sidebarDisplayed;
        },
        coreLoaded() {
            return this.$store.state.coreLoaded;
        },
    },
    created() {
        this.$store.state.firstLoad = true;
        window.addEventListener('resize', this.onWindowResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.onWindowResize);
    },
    methods: {
        openTeamSwitcher() {
            this.$store.state.modals.teamSwitcher = true;
        },
        openContactModal() {
            this.$store.state.modals.contactModal = true;
        },
        hideTutorial() {
            this.$store.dispatch('hideTutorial');
        },
        onWindowResize(e) {
            if (window.innerWidth <= this.$store.state.sidebarBP && this.windowWidth > window.innerWidth && !this.sidebarDisplayed) {
                this.$store.dispatch('showSidebar');
            }
            if (window.innerWidth > this.$store.state.sidebarBP && this.windowWidth < window.innerWidth && this.sidebarDisplayed) {
                this.$store.dispatch('hideSidebar');
            }
            
			this.windowWidth = window.innerWidth;
        },
        closeNotificationBox(type) {
            // console.log(type);
        },
    },
    render: (h) => h(App),
}).$mount('#app');
